import { Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from './services';

@Component({
    selector: 'app-home',
    imports: [CommonModule],
    template: `
    <div class="container">
      <div>
        <img src="/assets/midstate_logo.webp" alt="logo" />
      </div>
      <h1>Welcome, {{ user().name }}</h1>
    </div>
  `,
    styles: [
        `
      .container {
        margin: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    `
    ]
})
export class HomeComponent {
  auth = inject(AuthService);
  router = inject(Router);

  user = this.auth.user;

  constructor() {
    effect(() => {
      console.log('HomeComponent effect');
      if (this.auth.user().roles?.includes('Administrator')) {
        this.router.navigate(['/mdoc/sat-referral']);
      } else {
        this.router.navigate(['/mdoc/sat-referral/create']);
      }
    });
  }
}
